import type { QueryParameters } from "./QueryParameters";
import type { ServerFile } from "./ServerFile";
import type { RefUser } from "./Users";



export interface Demande {
    id: number,
    titre: string,
    montant: number,
    date_creation: string,
    id_inscription: number,
    inscription?:RefUser,
    prestataire: number,
    service: number,
    assistant: number,
    frais: Record<string,number>,
    aides_tech: number,
    transports: number,
    soins: number,
    heures: number,
    year: number,
    fond_id: number,
    statut: demandeStatus,
    comment: string,
    justificatifs:ServerFile[],
    preuves:ServerFile[],
    declarations:ServerFile[]
}

interface DemandeFormFiles{
    justificatifs:ServerFile[],
    preuves:ServerFile[],
    declarations:ServerFile[] 
}
interface DemandeIdentifier {
    readonly id: number;
}
interface DemandeOperatorFields{
    statut: demandeStatus,
    comment:string,
    fond_id: number,
}
export type DemandeForm = Omit<Demande,'id' | 'statut' | 'comment' | 'id_inscription' | 'date_creation' | 'preuves' | 'declarations' > ;
export type DemandeUpdate = DemandeForm & DemandeIdentifier;
export type DemandeOperatorUpdate = DemandeIdentifier & DemandeOperatorFields;

export type DemandeInsert = DemandeForm & DemandeFormFiles;


export type demandeStatus= "en_cours" | "accepte" | "paye" | "refuse"| "attente";


export const emptyDemande = (): DemandeInsert => ({
    titre: '',
    montant: 0,
    prestataire: 0,
    year:new Date().getFullYear(),
    service: 0,
    assistant: 0,
    frais: {},
    fond_id: 0,
    transports: 0,
    soins: 0,
    aides_tech:0,
    heures: 0,
    justificatifs:[],
    preuves:[],
    declarations:[],
});


export const demandeStatusNames:Record<demandeStatus,string> = {
  "en_cours": "En Cours",
  "accepte": "Accepté",
  "paye": "Payé",
  "refuse": "Refusé",
  "attente": "En Attente",
}
export const statusList:demandeStatus[] =['en_cours','accepte','refuse','attente','paye'];

export function statusDispo(statut:demandeStatus):demandeStatus[]{
    if(statut=='en_cours'){
        return ['en_cours','accepte','refuse','attente'];
    }else if(statut=='accepte'){
        return ['accepte','paye'];
    }else if(statut=='attente'){
        return ['attente','accepte','refuse'];
    }
    else if(['refuse','paye'].includes(statut) ){
        return ['refuse','paye'];
    }else{
        return [statut];
    }
}

export interface DemandeLookupParameters{
    [index: string]:string[] | string | number[]| number | undefined;
    statut?:string[] ,
    year?:   number[]| number ,
}
export type DemandeParameters = Omit<QueryParameters,'r'> & { r:DemandeLookupParameters }